/**
 * Visible width of the skill panel when collapsed. Applied inline in `SkillPanel.tsx`
 * so open/close width transitions can run (CSS cannot interpolate `auto`).
 */
export const SKILL_PANEL_COLLAPSED_CHROME_WIDTH_PX = 60;

/**
 * Duration of `.skill-panel { transition: width ... }` in `main.css` (ms).
 * Used so viewport centering runs after the collapse animation finishes.
 */
export const SKILL_PANEL_WIDTH_TRANSITION_MS = 350;

/**
 * True when an expanded skill panel at `skillPanelWidthPx` would cover more than
 * half of the viewport (skill-trees-4hv narrow layout).
 */
export function skillPanelExpandedCoversMoreThanHalfScreen(
    viewportWidthPx: number,
    skillPanelWidthPx: number,
): boolean {
    return skillPanelWidthPx > viewportWidthPx / 2;
}
